<div class="table mt-0050"
     data-test-id="category">
  <div class="tr tile__heading tr--noGutter"
       [ngClass]="{'bg-muted': !hasAppliedTags }"
       title="Field: {{category.name}}">

    <span class="tile__heading--label truncate">{{category.name}}</span>

    <i class="fal fa--gray ml-0025"
       [ngClass]="getTagTypeIcon(category)"></i>

    <ng-container >
      <i class="fal fa-solar-system color--purple ml-0025"
         matTooltip="This is a universal field; responses belonging to this field are available across all campaigns for which this field is enabled."
         *ngIf="category.isUniversal"></i>
    </ng-container>

    <ng-container *ngIf="showTaskDoneMark">
      <span class="color--gray ml-0050">
        &bull;
        <span class="color--green">
          <span class="d-none d-inline--md uppercase ml-0025">Done</span>
          <i class="far fa-check ml-0025"></i>
        </span>
      </span>
    </ng-container>

    <ng-container>
      <div class="d-flex flexJustify-end flexAlign-center flexWrap-nowrap ml-auto">

        <ng-container *ngIf="category.readonly">
          <ng-container *appIfInRole="['Administrator']">
            <span class="read-only-label color--gray">Read Only</span>
            <button mat-button
                    class="addNew lh-normal pl-0075 pr-0 mat-button--no-ripple mat-button--no-focus-overlay"
                    (click)="addTagClicked(category)"
                    [disableRipple]="true">
              <i class="far fa-plus addNew__icon"></i>
              Add
            </button>
          </ng-container>

          <ng-container *appIfInRole="['Activist', 'Organizer', 'Lead']">
            <span class="read-only-label pill-like">Read Only</span>
          </ng-container>

        </ng-container>

        <ng-container *ngIf="!category.readonly">
          <button mat-button
                  class="addNew lh-normal pl-0075 pr-0 mat-button--no-ripple mat-button--no-focus-overlay"
                  (click)="addTagClicked(category)"
                  [disableRipple]="true">
            <i class="far fa-plus addNew__icon"></i>
            Add
          </button>
        </ng-container>
      </div>
    </ng-container>


  </div>

  <app-applied-tag-row *ngFor="let appliedTag of (showAll ? appliedTagsForCategory : initiallyVisibleTags)"
                       [appliedTag]="appliedTag"
                       class="tr tr--tag tr--tag--{{appliedTag.tag.tagType | lowercase}}"></app-applied-tag-row>

  <div class="tr tr--noGutter tr--sm tile__footing tile__footing--border pt-0 pb-0 pr-0"
       *ngIf="appliedTagsForCategory.length > initialTagsVisible">
    <button mat-button
            class="addNew ml-auto"
            (click)="showAll = !showAll">
      <ng-container *ngIf="!showAll">
        <span class="addNew__text">
          Show All <strong>{{appliedTagsForCategory.length}}</strong> Responses
        </span>
        <mat-icon fontSet="far"
                  fontIcon="fa-chevron-down"
                  class="h-auto color--gray"></mat-icon>
      </ng-container>
      <ng-container *ngIf="showAll">
        <span class="addNew__text">
          Hide Responses
        </span>
        <mat-icon fontSet="far"
                  fontIcon="fa-chevron-up"
                  class="h-auto color--gray"></mat-icon>
      </ng-container>
    </button>
  </div>
</div>
